import axios from 'axios';

const consultaCep = axios.create({
	// baseURL: 'https://delphus.cf:21453/api/'
	baseURL: 'https://viacep.com.br/ws/'
});

export default consultaCep